import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ListObject } from '../../../../../common/models/list.model';
import { getQueryStringFromObject } from '../../../../../common';
import { API_URL } from '../../../../../services/config';
import { WrapperHttpService } from '../../../../services/wrapper-http-service';
import { MasterDataEndpoint, MasterDataType } from '../constants';
import { MasterDataReportItemModel, MasterDataReportListSearchCriteria } from '../models';

@Injectable({
  providedIn: 'root',
})
export class MasterDataReportItemService {
  constructor(private http: WrapperHttpService) {}

  getReportItemList(
    masterDataId: string,
    type: MasterDataType,
    params: MasterDataReportListSearchCriteria,
  ): Observable<ListObject<MasterDataReportItemModel>> {
    const pathByType: { [key: string]: MasterDataEndpoint } = {
      [MasterDataType.Address]: MasterDataEndpoint.Address,
      [MasterDataType.Carrier]: MasterDataEndpoint.Carrier,
      [MasterDataType.User]: MasterDataEndpoint.User,
    };
    const url =
      `${API_URL}${MasterDataEndpoint.Base}${pathByType[type]}${MasterDataEndpoint.Find}?` +
      getQueryStringFromObject({ masterDataId, ...params });

    return this.http.withLoading().get<ListObject<MasterDataReportItemModel>>(url);
  }
}
